<template>
  <div class="bg-[rgb(15,23,42)] py-3 px-6">
    <div class="container mx-auto max-w-[1200px]">
      <div class="flex items-center justify-between">
        <router-link
          :to="{ name: 'AdminHome' }"
          class="brand w-nav-brand w--current flex items-center"
        >
          <img
            :src="logo_image"
            alt="Logo"
            class="w-20 sm:w-24 md:w-32 lg:w-36 xl:w-40 py-4 object-contain"
          />
        </router-link>

        <div class="flex items-center">
          <div
            class="text-[#0085DB] px-5 font-bold hidden md:block"
            v-if="this.userInfo"
          >
            {{
              this.userInfo.user.permission.charAt(0).toUpperCase() +
              this.userInfo.user.permission.slice(1)
            }}
          </div>
          <div class="hidden md:flex items-center gap-5">
            <div class="mr-10 flex items-center gap-10">
              <div class="relative cursor-pointer dropdown-container">
                <div
                  class="flex items-center gap-2"
                  @click="MenuToggle('menu')"
                >
                  <p class="text-xs text-white hover:text-white font-medium">
                    Menu
                  </p>
                  <img src="@/assets/newd/down.png" class="w-3" alt="" />
                </div>

                <div
                  class="absolute right-0 top-12 z-50 bg-white rounded-2xl shadow-lg"
                  style="width: 180px"
                  v-if="toggleMenuName == 'menu'"
                >
                  <router-link
                    :to="{ name: 'AdminDashboards' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-t-2xl"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminDashboards',
                      'text-black': $route.name !== 'AdminDashboards',
                    }"
                  >
                    Dashboard
                  </router-link>

                  <hr />

                  <router-link
                    :to="{ name: 'AiCourseCreatePrompt' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'AiCourseCreatePrompt',
                      'text-black': $route.name !== 'AiCourseCreatePrompt',
                    }"
                  >
                    Ai Course Create
                  </router-link>

                  <hr />

                  <router-link
                    :to="{ name: 'PromptList' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'PromptList',
                      'text-black': $route.name !== 'PromptList',
                    }"
                  >
                    Ai Prompts
                  </router-link>

                  <hr />

                  <router-link
                    :to="{ name: 'BulkUploadCreate' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'BulkUploadCreate',
                      'text-black': $route.name !== 'BulkUploadCreate',
                    }"
                  >
                    Create User
                  </router-link>

                  <hr />

                  <!-- CourseDetailsUpdate -->

                  <!-- AICourseCreate -->

                  <router-link
                    :to="{ name: 'AdminNewCourses' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminNewCourses',
                      'text-black': $route.name !== 'AdminNewCourses',
                    }"
                  >
                    New Course</router-link
                  >

                  <hr />

                  <!-- <router-link
                    :to="{ name: 'CourseDetailsUpdate' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                    :class="{
                      'text-[#0085db]': $route.name === 'CourseDetailsUpdate',
                      'text-black': $route.name !== 'CourseDetailsUpdate',
                    }"
                  >
                    Course Details Update</router-link
                  >
                  <hr /> -->

                  <router-link
                    :to="{ name: 'AdminCoursess' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminCoursess',
                      'text-black': $route.name !== 'AdminCoursess',
                    }"
                  >
                    <p>Courses</p>
                  </router-link>

                  <hr />

                  <router-link
                    :to="{ name: 'AdminStudentAssign' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminStudentAssign',
                      'text-black': $route.name !== 'AdminStudentAssign',
                    }"
                  >
                    <p>Student Assign</p>
                  </router-link>

                  <hr />
                  <router-link
                    :to="{ name: 'InstructorBlogsView' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'InstructorBlogsView',
                      'text-black': $route.name !== 'InstructorBlogsView',
                    }"
                  >
                    New Blog</router-link
                  >

                  <hr />

                  <router-link
                    :to="{ name: 'InstructorBlogsList' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'InstructorBlogsList',
                      'text-black': $route.name !== 'InstructorBlogsList',
                    }"
                  >
                    Blogs</router-link
                  >
                  <hr />
                  <router-link
                    :to="{ name: 'AdminUpload' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminUpload',
                      'text-black': $route.name !== 'AdminUpload',
                    }"
                  >
                    Single Upload</router-link
                  >

                  <hr />
                  <router-link
                    :to="{ name: 'DownloadHistory' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-b-2xl"
                    :class="{
                      'text-[#0085db]': $route.name === 'DownloadHistory',
                      'text-black': $route.name !== 'DownloadHistory',
                    }"
                  >
                    Download History</router-link
                  >

                  <hr />
                </div>
              </div>
            </div>
          </div>

          <!-- Message -->

          <div class="mr-7 relative dropdown-container">
            <div class="relative" @click="MenuToggle('messages')">
              <p
                class="bg-white flex items-center justify-center text-primary !w-[25px] !h-[25px] text-xs rounded-full absolute -top-6 -right-5"
              >
                {{ messageCount || 0 }}
              </p>

              <img
                src="@/assets/new/chat.svg"
                width="20"
                height="20"
                class="cursor-pointer"
              />
            </div>
            <div
              v-if="toggleMenuName == 'messages'"
              class="absolute right-[-120px] lg:right-0 top-14 lg:top-10 w-64 z-10 bg-white rounded-2xl shadow-lg p-4"
            >
              <div class="font-bold text-sm pb-3 flex items-center gap-2">
                Messages
                <p
                  class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
                  v-if="messageCount != 0"
                >
                  {{ messageCount }}
                </p>
              </div>

              <div class="flex flex-col gap-2">
                <div
                  v-if="this.messageList.length != 0"
                  class="flex flex-col gap-2"
                >
                  <router-link
                    :to="{ name: 'StudentMessagesList' }"
                    class="flex flex-col border gap-1 py-2 px-4 rounded-lg"
                    v-for="message in this.messageList.slice(0, 3)"
                    :key="message"
                  >
                    <p class="font-bold text-sm line-clamp-1">
                      {{ message.course_title }}
                    </p>
                    <p class="font-bold text-sm line-clamp-1">
                      Semester:{{ message.semester }}
                    </p>
                    <p class="text-xs">
                      {{
                        new Date(message.created_at).toLocaleDateString("en-IN")
                      }}
                    </p>
                  </router-link>

                  <router-link
                    :to="{ name: 'StudentMessagesList' }"
                    v-if="this.messageList.length > 3"
                    class="text-blues font-bold text-xs py-2"
                    >See More</router-link
                  >
                </div>
                <router-link
                  :to="{ name: 'StudentMessagesList' }"
                  v-if="this.messageList.length == 0"
                  class="flex text-sm flex-col border gap-1 py-2 px-4 rounded-lg"
                  >No Data Found</router-link
                >
              </div>
            </div>
          </div>

          <!-- notification -->

          <div class="mr-10 relative dropdown-container">
            <div class="relative" @click="MenuToggle('notification')">
              <p
                class="bg-white flex items-center justify-center text-primary !w-[25px] !h-[25px] text-xs rounded-full absolute -top-5 -right-5"
              >
                {{ this.notificationCount || 0 }}
              </p>

              <img
                src="@/assets/notification.png"
                width="24"
                height="24"
                class="cursor-pointer"
              />
            </div>

            <div
              class="absolute right-[-70px] lg:right-0 top-14 lg:top-10 w-64 z-10 bg-white rounded-2xl shadow-lg p-4"
              style="width: 250px"
              v-if="toggleMenuName == 'notification'"
            >
              <div class="font-bold text-sm pb-3 flex items-center gap-2">
                Notifications
                <p
                  class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
                  v-if="this.notificationCount != 0"
                >
                  {{ this.notificationCount }}
                </p>
              </div>
              <div class="flex flex-col gap-2">
                <div
                  v-if="this.notificationList.length != 0"
                  class="flex flex-col gap-2"
                >
                  <!-- <router-link :to="{ name: 'InstructorNotifcations' }" class="flex flex-col border gap-1 py-2 px-4 rounded-lg" v-for="notifi in this.notificationList" :key="notifi">
                    <p class="font-bold text-xs">{{ notifi.topic }}</p>
                    <p class="text-xs">{{ new Date(notifi.created_at).toLocaleDateString("en-IN") }}</p>
                  </router-link> -->
                  <router-link
                    :to="{ name: 'StudentNotifications' }"
                    class="flex flex-col border gap-1 py-2 px-4 rounded-lg"
                    v-for="notifi in this.notificationList.slice(0, 3)"
                    :key="notifi"
                  >
                    <p class="font-bold text-xs">{{ notifi.topic }}</p>
                    <p class="text-xs">
                      {{
                        new Date(notifi.created_at).toLocaleDateString("en-IN")
                      }}
                    </p>
                  </router-link>

                  <router-link
                    :to="{ name: 'StudentNotifications' }"
                    v-if="this.notificationList.length > 3"
                    class="text-blues font-bold text-xs py-2"
                    >See More</router-link
                  >
                </div>

                <!-- <div class="flex flex-col border gap-1 py-2 px-4 rounded-lg">
                  <p class="font-semibold text-xs">New course added for you!</p>
                  <p class="font-semibold text-xs">11/02/2025</p>
                </div>
                <div class="flex flex-col border gap-1 py-2 px-4 rounded-lg">
                  <p class="font-semibold text-xs">New course added for you!</p>
                  <p class="font-semibold text-xs">11/02/2025</p>
                </div> -->
                <router-link
                  :to="{ name: 'StudentNotifications' }"
                  v-if="this.notificationList.length == 0"
                  class="flex flex-col text-xs border gap-1 py-2 px-4 rounded-lg"
                  >No Data Found</router-link
                >

                <!-- <div class="flex flex-col border gap-1 py-2 px-4 rounded-lg">
                  <p class="font-semibold text-xs">New course added for you!</p>
                  <p class="font-semibold text-xs">11/02/2025</p>
                </div>
                <div class="flex flex-col border gap-1 py-2 px-4 rounded-lg">
                  <p class="font-semibold text-xs">New course added for you!</p>
                  <p class="font-semibold text-xs">11/02/2025</p>
                </div> -->
                <!-- <p>No Data Found</p> -->
              </div>
            </div>
          </div>

          <div class="relative dropdown-container">
            <div
              @click="MenuToggle('profile')"
              class="flex items-center cursor-pointer"
            >
              <!-- {{ userInfo.image }}  -->

              <img
                v-if="userInfo && userInfo.image && userInfo.image != null"
                :src="userInfo.image"
                class="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                v-else
                src="@/assets/new/image.png"
                class="w-10 h-10 rounded-full border-2 border-white"
              />

              <!-- <img
                v-if="isAuthenticated && profileInfo != null && profileInfo.data.profile"
                :src="profileInfo.data.profile"
                class="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                v-else
                src="@/assets/new/image.png"
                class="w-10 h-10 rounded-full border-2 border-white"
              /> -->
            </div>

            <div
              class="absolute right-0 top-14 lg:top-20 z-50 bg-white rounded-2xl shadow-lg"
              style="width: 180px"
              v-if="toggleMenuName == 'profile'"
            >
              <!-- <div class="flex items-center gap-2 py-3 px-6 cursor-pointer">
                <img
                  src="@/assets/new/profile.png"
                  width="20"
                  height="20"
                  alt=""
                />

                <router-link
                  :to="{ name: 'StudentHome' }"
                  class="text-xs font-medium"
                  style="color: #333333 !important"
                  >Profile</router-link
                >
              </div> -->
              <router-link
                :to="{ name: 'AdminProfile' }"
                class="flex items-center gap-2 py-3 px-4 text-xs cursor-pointer hover:bg-slate-200 hover:rounded-t-2xl"
              >
                <img
                  src="@/assets/new/profile.png"
                  class="w-5 h-5"
                  alt="Profile"
                />
                <div>
                  <span
                    class="font-semibold"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminProfile',
                      'text-gray-800': $route.name !== 'AdminProfile',
                    }"
                    >Profile</span
                  >
                  <!-- <span>62135458</span>
                  <span>Compt Science</span> -->
                </div>
              </router-link>
              <hr />
              <router-link
                v-if="checkinTheList('Timetable')"
                :to="{ name: 'AdminTimeTable' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'AdminTimeTable',
                  'text-gray-800': $route.name !== 'AdminTimeTable',
                }"
              >
                <p>Time Table</p>
              </router-link>

              <!-- <hr v-if="checkinTheList('Timetable')" /> -->

              <router-link
                v-if="checkinTheList('Attendance')"
                :to="{ name: 'AdminAttendance' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'AdminAttendance',
                  'text-gray-800': $route.name !== 'AdminAttendance',
                }"
              >
                <p>Attendance</p>
              </router-link>

              <!-- <hr v-if="checkinTheList('Attendance')" /> -->

              <router-link
                :to="{ name: 'AdminMyTask' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'AdminMyTask',
                  'text-gray-800': $route.name !== 'AdminMyTask',
                }"
              >
                My Task</router-link
              >
              <hr />
              <router-link
                :to="{ name: 'AdminSyallbusView' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'AdminSyallbusView',
                  'text-gray-800': $route.name !== 'AdminSyallbusView',
                }"
              >
                Syllabus
              </router-link>
              <hr />

              <!-- <a
                href="https://coms.cambridge.edu.in/"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                target="blank"
              >
                Support</a
              >
              <hr /> -->

              <div
                class="flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-b-2xl"
                @click="
                  LogOutModal = true;
                  toggleMenuName = '';
                "
              >
                <img
                  src="@/assets/new/logout.png"
                  width="15"
                  height="15"
                  alt=""
                />
                <p
                  class="text-xs text-[#F87474] font-semibold"
                  style="color: #f87474 !important"
                >
                  Logout
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:hidden md:hidden relative dropdown-container">
          <button
            @click="MenuToggle('mobile_menu')"
            class="text-white focus:outline-none"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
          <div
            v-if="toggleMenuName == 'mobile_menu'"
            class="absolute right-6 top-20 z-50 bg-white rounded-2xl shadow-lg lg:hidden"
            style="width: 180px"
          >
            <router-link
              :to="{ name: 'AdminDashboards' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'AdminDashboards',
                'text-black': $route.name !== 'AdminDashboards',
              }"
            >
              Dashboard
            </router-link>

            <hr />

            <router-link
              :to="{ name: 'BulkUploadCreate' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'BulkUploadCreate',
                'text-black': $route.name !== 'BulkUploadCreate',
              }"
            >
              User Create
            </router-link>

            <hr />

            <router-link
              :to="{ name: 'AdminNewCourses' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'AdminNewCourses',
                'text-black': $route.name !== 'AdminNewCourses',
              }"
            >
              New Course</router-link
            >

            <hr />

            <router-link
              :to="{ name: 'AdminCoursess' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
            >
              <p>Courses</p>
            </router-link>

            <hr />

            <router-link
              :to="{ name: 'AdminStudentAssign' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
            >
              <p>Student Assign</p>
            </router-link>

            <hr />
            <router-link
              :to="{ name: 'InstructorBlogsView' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'InstructorBlogsView',
                'text-black': $route.name !== 'InstructorBlogsView',
              }"
            >
              New Blog</router-link
            >

            <hr />

            <router-link
              :to="{ name: 'InstructorBlogsList' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'InstructorBlogsList',
                'text-black': $route.name !== 'InstructorBlogsList',
              }"
            >
              Blogs</router-link
            >
            <hr />
            <router-link
              :to="{ name: 'AdminUpload' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
              :class="{
                'text-[#0085db]': $route.name === 'AdminUpload',
                'text-black': $route.name !== 'AdminUpload',
              }"
            >
              Single Upload</router-link
            >

            <hr />
            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-b-2xl"
              :class="{
                'text-[#0085db]': $route.name === 'DownloadHistory',
                'text-black': $route.name !== 'DownloadHistory',
              }"
            >
              Download History</router-link
            >

            <hr />
            <!-- <div>
              <button
                @click="
                  this.invitecourse = true;
                  toggleMenuName = '';
                "
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                :class="{
                  ' text-[#0085db]': invitecourse,
                  ' text-black': !invitecourse,
                }"
              >
                Invite Course
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- invite course popup start -->
    <div
      v-if="this.invitecourse"
      @click.self="this.invitecourse = false"
      class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
    >
      <div class="md:w-[40%] 2xl:w-[35%] bg-white rounded-xl p-10">
        <div class="flex items-center justify-center">
          <h3 class="text-xl font-bold text-blues text-center">
            Invite Course
          </h3>
        </div>

        <div
          class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
        >
          <div class="w-full">
            <form
              ref="createTeamRef"
              @submit.prevent="invitepost"
              class="flex flex-col gap-4 text-xs md:text-xs lg:text-base h-full"
            >
              <div class="flex flex-col gap-3 w-full">
                <label for="category" class="flex gap-2 items-center">
                  <div>
                    Course list
                    <span class="text-red-400">*</span>
                  </div>
                </label>
                <select
                  name="course"
                  class="bg-[#F9FAFC] rounded-lg text-xs w-full p-3 border-none outline-none"
                  id="course"
                  required
                >
                  <option value="" disabled selected>Select course</option>
                  <option
                    v-for="course in courselist"
                    :key="course"
                    :value="course.title"
                  >
                    {{ course.title }}
                  </option>
                </select>
              </div>

              <div class="flex flex-col gap-3 w-full">
                <label for="studentmail" class="flex gap-2 items-center">
                  <div>Student list <span class="text-red-400">*</span></div>
                </label>

                <input
                  type="text"
                  id="studentmail"
                  v-model="searchQuery"
                  @input="Studentsearch"
                  placeholder="Search email"
                  class="bg-[#F9FAFC] rounded-lg text-xs w-full p-3 border-none outline-none"
                />
                <ul
                  v-if="showdetail == false && this.studentlist.length > 0"
                  class="bg-white w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1"
                >
                  <li
                    v-for="student in studentlist.slice(0, lengthCount)"
                    :key="student.email"
                    class="p-2 cursor-pointer hover:bg-gray-100"
                    @click="selectStudent(student.email)"
                  >
                    {{ student.email }}
                  </li>
                </ul>
              </div>

              <div class="flex justify-center pb-4 mt-3 gap-10">
                <button
                  @click="closepopup"
                  class="border text-gray-500 rounded-lg text-xs px-10 font-semibold py-2"
                >
                  Close
                </button>
                <div class="flex gap-3 items-center">
                  <button
                    :disabled="disableStatus"
                    :class="{
                      'cursor-not-allowed bg-gray-200 text-black':
                        disableStatus === true,
                      'cursor-pointer bg-blues text-white ':
                        disableStatus === false,
                    }"
                    type="submit"
                    class="rounded-lg text-xs px-10 font-semibold py-2"
                  >
                    Invite
                  </button>
                  <div v-if="loaders" class="spinner"></div>
                </div>
              </div>
              <div
                v-if="invite_messages"
                class="text-green-500 font-bold text-left px-2 py-2 rounded-lg"
              >
                {{ invite_messages }}
              </div>
              <div
                v-if="invite_err_messages"
                class="text-red-500 font-bold text-left px-2 py-2 rounded-lg"
              >
                {{ invite_err_messages }}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- invite course popup end -->
    <Logout
      v-if="LogOutModal"
      @logOut="logOut"
      @cancel="LogOutModal = !LogOutModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import axios from "axios";
// import $ from "jquery";
// import LogOutPopUp from "@/components/LogOutPopUp";
import Logout from "@/components/Logout.vue";

export default {
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "userInfo",
      "notificationCount",
      "permissionList",
      "messageCount",
    ]),
  },

  data() {
    return {
      logo_image: require(`${process.env.VUE_APP_COMS_LOGO}`),
      toggleMenuName: null,
      profileInfo: null,
      LogOutModal: false,
      notificationList: [],
      invitecourse: false,
      courselist: [],
      studentlist: [],
      invite_messages: "",
      mobileMenuOpen: false,
      loaders: false,
      disableStatus: false,
      invite_err_messages: "",
      searchQuery: "",
      showdetail: false,
      lengthCount: 10,
      // count:"",
      messageList: [],
      // messagecount: null,
    };
  },

  components: {
    Logout,
  },

  created() {
    this.getNotifications();
    // this.courselistget();
    this.studentlistget();
    // this.getMessages();
    if (this.userInfo) {
      console.log("start");
      let token = this.userInfo.token_key;
      let slug_id = this.userInfo.slug_id;
      axios
        .get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${token}&format=json`
        )
        .then((response) => (this.profileInfo = response.data));
    } else {
      console.log("Not Login");
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.$store.dispatch("connectMessageSocket");

    this.$store.commit("SET_ON_NEW_MESSAGE", () => {
      this.loadMessages(this.currentPage);
    });

    this.loadMessages();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    ...mapActions(["logOutUser"]),
    ...mapMutations(["notifyCount"]),
    async loadMessages(page = 1) {
      if (!this.userInfo) return;

      const data = await this.$store.dispatch("fetchMessageList", {
        userId: this.userInfo.user.id,
        token: this.userInfo.token_key,
        page,
      });

      this.messageList = data.data; // message array
      console.log("test//////////", data.total);
    },
    checkinTheList(feature) {
      // let bool = false;
      let check = this.permissionList.find((x) => x === feature);
      if (check != undefined) {
        return true;
        // console.log(check, "cjsfkad true");
      } else {
        // console.log(check, "cjsfkad false");
        return false;
      }
    },

    MenuToggle(name) {
      if (this.toggleMenuName == name) {
        this.toggleMenuName = null;
      } else {
        this.toggleMenuName = name;
      }
    },

    async getNotifications() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
            this.notifyCount(response.data.count);
            // this.count=response.data.count;
            this.lengthCount = this.notificationList.length;
          }
        });
    },

    async logOut() {
      await this.logOutUser();
      this.LogOutModal = false;
      this.$router.push({
        name: "Login",
      });
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.toggleMenuName = null;
      }
    },
    // courselistget() {
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/course-title-get/?Key=${this.userInfo.token_key}`
    //     )
    //     .then((res) => {
    //       if (res.data.data) {
    //         this.courselist = res.data.data;
    //       }
    //     });
    // },
    studentlistget() {
      axios
        .get(
          `${process.env.VUE_APP_API}/student-invite-email-get/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.data) {
            this.studentlist = res.data.data;
            console.log("  this.studentlist", this.studentlist);
          }
        });
    },
    invitepost(el) {
      let bodyVal = {
        email: el.target.elements.studentmail.value,
        course: el.target.elements.course.value,
        user: this.userInfo.user.id,
        status: true,
      };
      console.log("bodyVal", bodyVal);
      this.disableStatus = true;
      this.loaders = true;
      axios
        .post(
          `${process.env.VUE_APP_API}/invitation/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.invite_messages = response.data.message;

            this.loaders = false;

            setTimeout(() => {
              this.invite_messages = "";
              this.invitecourse = false;
              this.disableStatus = false;
              this.searchQuery = "";
              this.showdetail == false;
            }, 3000);
          } else if (response.data.status == 400) {
            this.loaders = false;
            this.invite_err_messages = response.data.error;
            setTimeout(() => {
              this.invite_err_messages = "";
              // this.invitecourse = false;
              this.disableStatus = false;
            }, 3000);
          } else {
            this.disableStatus = false;
          }
        })

        .finally(() => {
          this.loaders = false;
        });
    },
    // courselistget() {
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/courses/?instructor=${this.userInfo.Instructor_id}`
    //     )
    //     .then((res) => {
    //       if (res.data.data) {
    //         this.courselist = res.data.data;
    //         console.log("courselist////", this.courselist);
    //       }
    //     });
    // },

    Studentsearch() {
      this.showdetail = false;
      axios
        .get(
          `${process.env.VUE_APP_API}/student-invite-email-get/?search=${this.searchQuery}&${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.data) {
            this.studentlist = res.data.data;
            // this.showdetail == this.searchQuery.trim() !== "";
          }
        });
    },
    selectStudent(email) {
      this.searchQuery = email;
      this.showdetail = true;
      // this.invitecourse = false;
    },
    closepopup() {
      this.invitecourse = false;
      this.searchQuery = "";
      this.showdetail = false;
    },
    async getMessages() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/message-course-overall-details/?client__id=${this.userInfo.user.id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response) {
            this.messageList = response.data.data.data;
            this.messagecount = response.data.count;
          }
        });
    },
  },
};
</script>

<style scoped>
/* loader  */
.spinner {
  --d: 8.6px;
  width: 1.5px;
  height: 1.5px;
  border-radius: 50%;
  color: #5593e0;
  box-shadow: calc(1 * var(--d)) calc(0 * var(--d)) 0 0,
    calc(0.707 * var(--d)) calc(0.707 * var(--d)) 0 0.5px,
    calc(0 * var(--d)) calc(1 * var(--d)) 0 1px,
    calc(-0.707 * var(--d)) calc(0.707 * var(--d)) 0 1.4px,
    calc(-1 * var(--d)) calc(0 * var(--d)) 0 1.9px,
    calc(-0.707 * var(--d)) calc(-0.707 * var(--d)) 0 2.4px,
    calc(0 * var(--d)) calc(-1 * var(--d)) 0 2.9px;
  animation: spinner-a90wxe 1s infinite steps(8);
}

@keyframes spinner-a90wxe {
  100% {
    transform: rotate(1turn);
  }
}
</style>
